import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import FullScreenPanel from '@/components/designSystem/FullScreenPanel/FullScreenPanel.vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'DashboardModalShell', inheritAttrs: false },
  __name: 'DashboardModalShell',
  props: {
    open: { type: Boolean },
    fullScreen: { type: Boolean },
    title: {},
    meta: { default: undefined },
    testId: { default: 'full-screen-panel' }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

/**
 * "Casca" dos modais do dashboard (spec 2026-09-30 §5 R6): o `ModalVue` de sempre no
 * desktop ou o `FullScreenPanel` no celular, com o MESMO conteúdo. O consumidor não
 * duplica o template: `header`/`footer` só vão para o modal, `header-extra`/`dock`
 * só para o painel, e o corpo vai para os dois.
 *
 * `inheritAttrs: false` + `v-bind="$attrs"` no `ModalVue`: os atributos de hoje
 * (`hasHeaderBorder`, a classe `modal-pushed-by-sidebar`, `min-height`) continuam
 * chegando ao modal, e nunca ao painel.
 */






// O painel só emite `false` ("←" ou Esc); abrir é sempre decisão do consumidor.
function onPanelToggle(value: boolean) {
  if (!value) emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_ctx.fullScreen)
    ? (_openBlock(), _createBlock(FullScreenPanel, {
        key: 0,
        "model-value": _ctx.open,
        title: _ctx.title,
        meta: _ctx.meta,
        "test-id": _ctx.testId,
        "onUpdate:modelValue": onPanelToggle
      }, _createSlots({
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        (_ctx.$slots['header-extra'])
          ? {
              name: "header-extra",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "header-extra")
              ]),
              key: "0"
            }
          : undefined,
        (_ctx.$slots.dock)
          ? {
              name: "dock",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "dock")
              ]),
              key: "1"
            }
          : undefined
      ]), 1032, ["model-value", "title", "meta", "test-id"]))
    : (_openBlock(), _createBlock(ModalVue, _mergeProps({ key: 1 }, _ctx.$attrs, {
        "modal-active": _ctx.open,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }), _createSlots({
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        (_ctx.$slots.header)
          ? {
              name: "header",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "header")
              ]),
              key: "0"
            }
          : undefined,
        (_ctx.$slots.footer)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _renderSlot(_ctx.$slots, "footer")
              ]),
              key: "1"
            }
          : undefined
      ]), 1040, ["modal-active"]))
}
}

})